export default __webpack_public_path__ + "static/media/latte.2e95dab9.webp";